import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import withUserGroupMembership from 'modules/shell/hoc/withUserGroupMembership';
import { fetchGroupClients, fetchGroupDetails } from 'modules/clients/actions';
import { DISABLE_EMAIL_RECIPIENTS_LIMIT } from 'constants/featureToggleNames';

import GroupRecipientsList from './GroupRecipientsList';

import styles from './GroupRecipientsList.styles';

const mapStateToProps = ({
  clientsModule: {
    groups: {
      groupDetails: { data: groupData, loading: groupDataLoading },
    },
  },
  clientingModule: { conversation },
  user,
}) => ({
  groupData,
  groupDataLoading,
  isBgUserBrand: user?.data?.brand === 'BG',
  initialSelectedRecipientsAmount: conversation.recipients?.length,
});

const mapDispatchToProps = {
  fetchGroupClients,
  fetchGroupDetails,
};

export default compose(
  withStyles(styles),
  withUserGroupMembership({
    isUserDCA: 'client_advisor',
  }),
  withFeatureToggles({
    isEmailRecipientsLimitDisabled: DISABLE_EMAIL_RECIPIENTS_LIMIT,
  }),
  connect(mapStateToProps, mapDispatchToProps),
)(GroupRecipientsList);
